import React, {Component, ReactNode} from 'react';
import {InfoIcon} from 'components/Icon';
import './index.scss';

interface NoteProps {
  children: ReactNode;
}

export default class Note extends Component<NoteProps> {
  render() {
    return <div className="note">
      <InfoIcon />
      <span>{ this.props.children }</span>
    </div>;
  }
}